import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter, useIonViewDidLeave, useIonViewDidEnter } from '@ionic/react'
import { UseHeader, MktLoading, MktEmpty } from '@cps'
import { memberMobx, activityMobx } from '@mobxStore'
import ActivityApi from '@api/activity.api'
import { FixBackHeader, NoticeModal } from '@pages/mkt/components'
import { modalLayer, useHistoryNew, toast, getCouponsInfo } from '@utils'
import { getParams } from '@dt/fe-utils'
import mktController from 'controllers/mktController'
import { reduce, values, keyBy } from '@dt/fe-utils/dist/lodash'
import i18n from 'i18next'
import Coupons from '../components/Coupons'
import ActivityDetail from '../../components/activityDetail'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const CouponsGet: FC<IProps> = ({ match }) => {
  const { activityId } = match.params as any
  const { isNewMember } = getParams()
  const history = useHistoryNew()
  const [activeStatus, setActiveStatus] = useState<boolean>(true)
  const [activeInfo, setActiveInfo] = useState<any>({})
  const [couponCount, setCouponCount] = useState<number>(0)
  const [memberAvatar, setMemberInfo] = useState<any>({})
  const [couponDetails, setCouponDetails] = useState<any>({})
  const [showLoading, setShowLoading] = useState<boolean>(true)
  const { isLogin, memberInfo } = memberMobx
  const { getActiveDetail } = activityMobx
  // Component Event
  const goReceive = () => {
    if (!activeStatus) {
      toast({ message: i18n.t('mkt.market.eventIsOver') })
      return
    }
    mktController.checkLogin(history).then(() => {
      history.push(`/activity/couponsSend/${activityId}`)
    })
  }
  // Data Method
  const getActiveData = () => {
    getActiveDetail(activityId).then((res: any) => {
      setShowLoading(false)
      if (res) {
        setActiveInfo(res)
        alertTip(res)
        if (res?.isOver) {
          setActiveStatus(false)
        } else {
          const count = reduce(values(res.coupons), (sum: any, i: any) => sum + i.couponCnt, 0)
          transCoupons(res.coupons)
          setCouponCount(count)
        }
      } else {
        setActiveStatus(false)
      }
    })
  }
  const alertTip = (info: any) => {
    if (Object.keys(info).length !== 0 && memberMobx.isMember && (isNewMember || memberMobx.isNewMember)) {
      const title = i18n.t('mkt.coupon.receivedNotice')
      const des = i18n.t('mkt.coupon.receivedNoticeDes', { username: memberMobx.memberInfo.nickName })
      memberMobx.isNewMember = false
      succAlert(title, des)
      return
    }
    if (Object.keys(info).length !== 0 && memberMobx.isMember && (!isNewMember && !memberMobx.isNewMember)) {
      const title = i18n.t('common.reminder')
      const des = info.extra?.invitationType === 'memberConsume' ? i18n.t('mkt.activity.failReceive') : i18n.t('mkt.activity.failReceive1')
      succAlert(title, des)
      return
    }
  }
  const transCoupons = (coupons: any) => {
    ActivityApi.getCouponsList({ couponIds: coupons.map(item => item.couponId) }).then(res => {
      const obj = keyBy(res, 'couponId')
      setCouponDetails(obj)
    })
  }
  const getMemberInfo = (id: number) => {
    ActivityApi.getMemberInfo({ brandId: memberMobx.brandId, memberIds: [id] }).then((res: any) => {
      if (res) {
        setMemberInfo(res[id])
      }
    })
  }
  const succAlert = (title: string, des: string) => {
    modalLayer(NoticeModal, {
      title,
      des
    }).then(() => { }, () => { })
  }
  const getRule = () => {
    modalLayer(ActivityDetail, {
      children: (
        <>
          {activeInfo.extra.copywriting && (
            <div className='detail-des'>
              <div className='title'>{i18n.t('mkt.activity.introduce')}</div>
              <div className='des'>{activeInfo.extra.copywriting}</div>
            </div>
          )}
        </>
      )
    }).then(() => { }, () => { })
  }
  // Component Effect
  useIonViewDidEnter(() => {
    getActiveData()
  })
  useIonViewDidLeave(() => {
    setShowLoading(false)
  }, [])
  useEffect(() => {
    if (Config.shareInfo) {
      const shareInfoObj: any = JSON.parse(decodeURIComponent(Config.shareInfo))
      getMemberInfo(shareInfoObj.memberId)
    }
  }, [Config.shareInfo])
  return (
    <IonPage className='coupon-get-page'>
      {
        activeStatus ? <FixBackHeader text={i18n.t('mkt.market.marketDetail')} onClick={getRule} /> : <UseHeader title={activeInfo.activityName} onBack={() => history.replace('/my')} />
      }
      <IonContent className='page-content'>
        {showLoading && <MktLoading></MktLoading>}
        <div className='page-body'>
          {
            activeStatus ? (
              <div>
                <img className='activity-img' src={activeInfo.playbill} />
                <div className='activity-info'>
                  <div className='activity-block'>
                    <Coupons
                      coupons={activeInfo.coupons || []}
                      couponDetails={couponDetails}
                      count={getCouponsInfo(activeInfo.coupons, 'cnt', couponDetails)}
                      onClick={goReceive}
                      title={isLogin && memberInfo.type === 'member' ? i18n.t('mkt.activity.shareCoupon') : i18n.t('mkt.activity.register')}
                    >
                    </Coupons>
                  </div>
                </div>
              </div>
            ) : (
              <div className='activity-end'>
                <MktEmpty type='end' text={activeInfo?.activityId ? i18n.t('mkt.market.eventIsOver') : i18n.t('mkt.market.activityNotExist')}></MktEmpty>
              </div>
            )
          }
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(CouponsGet)
